import React from "react";
import moment from "moment";

import { IColum } from "../../../../utils/copyToClipboardInXlsFormat";
import { CopyToClipboard } from "../../../../components/ui";
import { IntlFormatUSD } from "../../../../utils";
import { CENTS_IN_DOLLAR, DATE_FORMAT } from "../../../../constants";
import { IFailedResponse } from "../../../../api/compliance/index.types";

export const FAILED_COLUMNS: Array<IColum> = [
  {
    by: "account_name",
    title: "Funded account name",
    path: "account_name",
  },
  {
    by: "name",
    title: "Name",
    path: "account.name",
    // @ts-ignore
    getCellValue: (
      value: string,
      restValues: IFailedResponse["data"]["results"]["rows"][number]
    ) => <CopyToClipboard value={value || restValues.submissions_outer_account?.name || ""} />,
    // @ts-ignore
    copyToClipBoardCallBack: (
      value: string,
      restValues: IFailedResponse["data"]["results"]["rows"][number]
    ) => {
      return value || restValues.submissions_outer_account?.name || "";
    },
  },
  {
    by: "amount_requested",
    title: "Amount",
    path: "amount_requested",
    copyToClipBoardCallBack: (value) => IntlFormatUSD(+value / CENTS_IN_DOLLAR),
    getCellValue: (value) => IntlFormatUSD(+value / CENTS_IN_DOLLAR),
  },
  {
    by: "compliance_status_changed_timestamp",
    title: "Failure date",
    path: "compliance_status_changed_timestamp",
    getCellValue: (value) => moment(value as string).format(DATE_FORMAT),
    copyToClipBoardCallBack: (value) => moment(value as string).format(DATE_FORMAT),
  },
  {
    by: "comment",
    title: "Reason",
    path: "comment",
  },
];
